import type { TrainingLessonSpecific } from './trainingLessonUi';

export const teacher2ReverenceEs: TrainingLessonSpecific = {
  intro:
    'Esta lección se enfoca en la ejecución real: reverencia, apoyo a líderes, ministración sencilla, y cómo un Maestro sostiene el orden espiritual sin ponerse intenso.',
  objectives: [
    'Entender cómo el Maestro promueve reverencia sin conflicto ni vergüenza.',
    'Aprender a apoyar a líderes (obispado/quórum) con iniciativa ordenada.',
    'Practicar ministración simple: notar, acercarse, invitar, acompañar.',
    'Mejorar trabajo en equipo con diáconos/sacerdotes (sin competir).',
    'Establecer un plan semanal: reverencia + servicio + fortalecimiento.',
  ],
  briefHeading: 'Reverencia y servicio en la práctica',
  briefBody:
    'Un Maestro firme invita al orden con mansedumbre, apoya a obispado y presidencias, ministrá con gestos simples, y colabora con diáconos y sacerdotes. El objetivo es un ambiente donde otros puedan adorar con el Espíritu.',
  scriptures: [
    { ref: 'DyC 121:43–44', text: 'Reprensión cuando sea necesario, luego amor, sin hipocresía.' },
    { ref: 'Moroni 6:5–6', text: 'Reuniones para orar, exhortar, fortalecer.' },
    { ref: 'DyC 20:53–54', text: 'Velar por la iglesia, fortalecer a los miembros.' },
    { ref: 'Mateo 5:16', text: 'Que vean vuestras buenas obras (sin presumir).' },
    { ref: 'Filipenses 2:3–4', text: 'Humildad, considerar a otros.' },
  ],
  didYouKnow: [
    'Reverencia no es "estar callado por miedo": es enfocar el corazón en Cristo y en los convenios.',
    'Un Maestro fuerte no es el que manda: es el que sirve y mejora el ambiente donde otros pueden adorar.',
  ],
  practiceItems: [
    'Antes de la reunión: escoger un "punto de enfoque" (ej.: escuchar 1 idea del discurso y anotarla)',
    'Reverencia sin pleito: practicar 2 frases suaves para invitar al orden (ej.: "vamos a ayudar con reverencia", "te acompaño un momento")',
    'Apoyo a líderes: preguntar a un líder "¿en qué puedo ayudar hoy?" y hacerlo',
    'Ministración simple: hablar con 1 persona (nuevo, solo, joven tímido) y hacer una invitación breve ("qué bueno verte", "siéntate aquí", "¿cómo te fue?")',
    'Trabajo en equipo: ayudar a un diácono o sacerdote a completar su tarea sin regañarlo',
    'Evaluación personal: escribir 1 cosa que hice bien y 1 cosa que mejoraré el próximo domingo',
  ],
  reflectionQuestions: [
    '¿Qué distracciones me roban la reverencia? ¿Cómo las cortaré?',
    '¿A quién puedo fortalecer esta semana con un gesto simple?',
    '¿Cómo puedo corregir sin orgullo y servir sin esperar reconocimiento?',
  ],
  actionText:
    'Domingo con intención: elige 1 hábito fijo para cada domingo (ej.: llegar temprano, orar antes, sentarme adelante, apuntar 1 idea y aplicarla).',
};
